const _0x175767 = _0x49b6;

function listenerCoundFav(t) {
    const n = _0x175767, o = {
        fGpiJ: ".fav_but i", bsABm: function (t, n) {
            return t === n
        }, oUSdD: n(457), ZLwEG: n(435), FqHdX: n(444)
    }, e = t, c = document[n(506)](".fav-count"), s = document[n(506)](o[n(401)]);
    o[n(456)](e, 0) ? (c[n(487)].display = o[n(490)], s.classList[n(520)](o[n(378)]), s.classList.add(n(444))) : (c[n(487)][n(397)] = n(399), s.classList[n(520)](o[n(463)]), s[n(395)][n(492)](o[n(378)]))
}

function headerDropdownFilter() {
    const t = _0x175767, n = {Rotfi: t(447), hAHDo: t(349)};
    document[t(358)](n.Rotfi).classList[t(525)](t(349)), document[t(358)](t(481))[t(395)][t(525)](n[t(428)])
}

function headerDropdownFilterform() {
    const t = _0x175767, n = {cwVmj: "filterDropdown", XpzRC: "show"};
    document[t(358)](n[t(424)])[t(395)][t(525)](n.XpzRC)
}

function profileDropdown() {
    const t = _0x175767, n = {nQDTL: t(537), xZTBv: t(527), ENQFc: "show"};
    document[t(358)](n[t(468)])[t(395)][t(525)]("show"), document[t(358)](n[t(452)])[t(395)][t(525)](n.ENQFc)
}

function seriesDropdown() {
    const t = _0x175767, n = {ACbMv: "seriesdrop", mSeRA: t(349), MMHer: t(477)};
    document[t(358)](n.ACbMv)[t(395)][t(525)](n[t(489)]), document.getElementById(n[t(425)])[t(395)][t(525)](n[t(489)])
}

function favoritesDropdown() {
    const t = _0x175767, n = {KtiGg: t(467)};
    document[t(358)](t(532))[t(395)][t(525)]("show"), document[t(358)](n[t(501)])[t(395)][t(525)]("show")
}

function mobmenuopen() {
    const t = _0x175767, n = {VSvqH: t(349), foLMH: "mob_menu_icon", qXoRM: t(347)};
    document[t(358)](t(370))[t(395)].toggle(n[t(433)]), document[t(358)](n[t(388)])[t(395)][t(525)](n.qXoRM)
}

function searchopen() {
    const t = _0x175767, n = {yEGGK: t(410), tIePE: t(349), ZBOqf: t(359)}, o = document.getElementById(n[t(429)]),
        e = document[t(358)](t(524));
    e.classList[t(474)](n[t(534)]) ? (e[t(395)][t(520)](n[t(534)]), document.body[t(395)][t(520)](t(359)), o.blur(), o[t(470)] = "") : (e[t(395)][t(492)](n[t(534)]), document[t(350)].classList[t(492)](n[t(476)]), o.focus())
}

function _0x49b6(t, n) {
    const o = _0x5e8b();
    return (_0x49b6 = function (t, n) {
        return t -= 317, o[t]
    })(t, n)
}

function _0x5e8b() {
    const t = [".stars-rating li a", "summ", "PNRsS", "favblock", "nQDTL", '<a class="button_more btn-expand">ещё</a>', "value", "NWnEh", "ksELd", "opacity", "contains", "322640bMgmzs", "ZBOqf", "seriestoggle", ".dropfilter #filterDropdown", "ETEiC", "XJXCu", "filterDropdown", "wwtpr", "ZeweB", "#favblock", "pyEcd", "gCnDY", "style", "favid", "mSeRA", "oUSdD", "bqvKw", "add", "#tabs-3", "scroll", "cUcbc", "177", ".dropdown-menu-category.show", "AaBBS", "tBkxo", "dcxDN", "KtiGg", "CCeVo", "#favorite_count", "iMPuw", "minify_content-info", "querySelector", "XrRsR", "fTcnP", "parentNode", "length", "height", "has", "yxLnX", "textContent", "rYjbA", "#avatardrop", "NePKa", "HPTZl", "ARmup", "remove", "ZsqGX", "CtKRz", "77312MSdcDF", "head-search", "toggle", "kMFvn", "avatardrop", "css", "#scroll_top", '<i class="icons-arrow-bot" aria-hidden="true"></i>', "not", "favoritesdrop", "AdEeV", "tIePE", "forEach", "kdLtF", "profiledrop", "dYmXD", "responseText", "replace", "evbTo", ".filter_btn", "addClass", "ajax", "hover", "POST", "3596614tsZgFW", "html,body", "5XEjJui", "always", "html, body", "OlnxH", "nHYpw", ".dropfilter", "#profiledrop", "WRTRd", "KytoS", "wSXbD", '<a href="#">Свернуть описание</a>', "blur", "FMATy", "WkMEr", '<a class="button_arrow btn-expand"><i class="icons-arrow-bot" aria-hidden="true"></i></a>', "#series-tabs", "click", "toggleClass", "timer", "each", "which", "IMWKs", "icons-close-bar", "hzecx", "show", "body", "initial", "8292jFmnzl", "BAfal", "text", "bRpQF", "#tabs-2", "#seriesdrop", "getElementById", "hide", "#scroll_top_btn", "closeButton", "ready", ".dropnav", "ещё", "hidden", "10WfzazX", "EUdKd", ".more-p", "bmsFl", "mobile_menu", "active", "tabs", "timer-close-block", "qMtwS", "6gCVxmj", "mmEmq", "TmkpR", "ZLwEG", "target", "NDQMY", "TvPLI", "html", "scrollTop", "offset", "oyqqX", "MlDwe", "sPdme", "foLMH", "KukHF", "RtsmN", "fail", "swPuv", ".scora", "FKDOj", "classList", "pOwnW", "display", "ljZsQ", "flex", ".favmod.active", "fGpiJ", "LvJGE", "YISVT", "ObCIw", ".dropfilter #filterBtnDropdown", "adWindow", "BBoqJ", "uPtDS", "jGaOn", "story", "yRpmP", "MwsOG", "lGEBJ", "oyLvW", "LLtgN", "iQYNk", "Ntzfd", "bpeqS", "wOxPR", "fLeRN", "5456223xkKaxW", "removeClass", "$1 ", "cwVmj", "MMHer", "fade", "ZvYUk", "hAHDo", "yEGGK", "750578VFRELH", ".btn-expand", "OfIIX", "VSvqH", "focus", "icons-fav-full", "after", "IErGP", "FPcVg", "ChRRR", "QSYuO", "animate", "3871016zlnwTp", "Owmft", "icons-fav", "#seriestoggle", "#favoritesdrop", "filterBtnDropdown", "RehNl", "keydown", "block", "expanded", "xZTBv", "hWEGu", "hasClass", "prev", "bsABm", "none", "stop_scroll_top", "IuuPX", "data", "padod", '<a href="#">Подробное описание</a>', "FqHdX"];
    return (_0x5e8b = function () {
        return t
    })()
}

function searchClosePopup() {
    const t = _0x175767, n = {FMATy: "head-search", RehNl: t(359)}, o = document[t(358)](t(410));
    document[t(358)](n[t(337)])[t(395)].remove(t(349)), document[t(350)][t(395)][t(520)](n[t(448)]), document.getElementById(t(410))[t(434)](), o[t(336)](), o[t(470)] = ""
}

function highlightStars(t, n) {
    const o = _0x175767, e = {
        fsdHR: o(464), rYjbA: function (t, n) {
            return t < n
        }, bqvKw: o(321)
    }, c = t.parentNode[o(509)].querySelectorAll(e.fsdHR);
    for (let t = 0; e[o(515)](t, n); t++) c[t].classList[o(492)](e[o(491)])
}

function resetStars(t) {
    const o = _0x175767, n = t[o(509)][o(509)].querySelectorAll(o(464));
    n[o(535)](t => {
        const n = o;
        t[n(395)][n(520)](n(321))
    })
}

function showAdWindow() {
    const n = _0x175767, o = {
        CtKRz: function (t, n) {
            return t === n
        }, kMFvn: function (t, n) {
            return t(n)
        }, pOwnW: n(343), CCeVo: n(361), kdLtF: n(450), sPdme: n(373), ZeweB: function (t, n, o) {
            return t(n, o)
        }
    };
    document.getElementById(n(406))[n(487)][n(397)] = o[n(536)], document[n(358)](o[n(387)])[n(487)][n(397)] = n(399);
    let e = 30;
    const c = document.getElementById(n(343));
    c.textContent = e;
    const s = o[n(483)](setInterval, () => {
        const t = n;
        e--, c[t(514)] = e, o[t(522)](e, 0) && (o[t(526)](clearInterval, s), document[t(358)](o[t(396)])[t(487)][t(397)] = t(457), document[t(358)](o[t(502)])[t(487)][t(397)] = o.kdLtF)
    }, 1e3)
}

function closeAdWindow() {
    const t = _0x175767, n = {QSYuO: t(457)};
    document[t(358)](t(406))[t(487)][t(397)] = n[t(440)]
}

(function () {
    const t = _0x49b6, n = _0x5e8b();
    for (; ;) try {
        if (361769 == +parseInt(t(523)) + -parseInt(t(430)) / 2 + parseInt(t(352)) / 3 + -parseInt(t(475)) / 4 * (-parseInt(t(325)) / 5) + parseInt(t(375)) / 6 * (-parseInt(t(323)) / 7) + parseInt(t(442)) / 8 + -parseInt(t(421)) / 9 * (-parseInt(t(366)) / 10)) break;
        n.push(n.shift())
    } catch (t) {
        n.push(n.shift())
    }
})(), $(document)[_0x175767(362)](function (c) {
    const s = _0x175767, t = {sDuRy: ".blockreadmore", TmkpR: s(462)};
    c(t.sDuRy).readmore({
        maxHeight: 170,
        speed: 100,
        moreLink: t[s(377)],
        lessLink: s(335),
        afterToggle: function (t, n, o) {
            const e = s;
            o || c(e(327))[e(441)]({scrollTop: n[e(384)]().top - 80}, {duration: 100})
        }
    })
}), $(document).on(_0x175767(341), function (t) {
    const n = _0x175767, o = {
        WkMEr: function (t, n) {
            return t(n)
        }, MwsOG: n(363), ObCIw: function (t, n) {
            return t === n
        }, LvJGE: n(349)
    }, e = o[n(338)]($, o[n(412)]), c = $(n(497));
    !e.is(t[n(379)]) && o[n(404)](e[n(512)](t[n(379)])[n(510)], 0) && c.removeClass(o[n(402)])
}), $(document).on(_0x175767(341), function (t) {
    const n = _0x175767, o = {
        WRTRd: function (t, n) {
            return t(n)
        }, YISVT: n(330), AaBBS: ".dropdown-filter-content.show", MlDwe: n(318), evbTo: function (t, n) {
            return t === n
        }, Owmft: n(349), fTcnP: n(478), AdEeV: n(405)
    }, e = o[n(332)]($, o[n(403)]), c = $(o[n(498)]), s = o.WRTRd($, o[n(386)]);
    !e.is(t[n(379)]) && o[n(317)](e[n(512)](t[n(379)])[n(510)], 0) && (c[n(422)](o[n(443)]), s[n(422)](n(349)));
    const r = $(o[n(508)]), i = $(o[n(533)]);
    r[n(454)]("show") && i.addClass(o[n(443)])
}), $(document).on("click", function (t) {
    const n = _0x175767, o = {
        yRpmP: function (t, n) {
            return t(n)
        }, wOxPR: ".avatar", ChRRR: function (t, n) {
            return t === n
        }, HPTZl: n(349)
    }, e = o[n(411)]($, o[n(419)]), c = $(n(331)), s = $(n(516));
    !e.is(t.target) && o[n(439)](e[n(512)](t.target).length, 0) && (c[n(422)](o[n(518)]), s.removeClass(o.HPTZl))
}), $(document).on("click", function (t) {
    const n = _0x175767, o = {
        iMPuw: function (t, n) {
            return t(n)
        }, ljZsQ: ".dropdown-block", OlnxH: function (t, n) {
            return t(n)
        }, TvPLI: n(445), hzecx: function (t, n) {
            return t === n
        }, dcxDN: "show"
    }, e = o[n(504)]($, o[n(398)]), c = o[n(328)]($, n(357)), s = o.iMPuw($, o[n(381)]);
    !e.is(t.target) && o[n(348)](e[n(512)](t[n(379)]).length, 0) && (c[n(422)](o[n(500)]), s[n(422)](n(349)))
}), $(document).on("click", function (t) {
    const n = _0x175767, o = {
        lGEBJ: function (t, n) {
            return t(n)
        }, gCnDY: "#favblock", ZvYUk: n(446), bpeqS: "show"
    }, e = o.lGEBJ($, o[n(486)]), c = o[n(413)]($, o[n(427)]);
    e.is(t[n(379)]) || 0 !== e.has(t[n(379)])[n(510)] || (e[n(422)](o[n(418)]), c[n(422)](o[n(418)]))
}), Array.from(document.getElementsByClassName(_0x175767(465)), t => t[_0x175767(514)] = t[_0x175767(514)][_0x175767(540)](/(\d)(?=(\d\d\d)+([^\d]|$))/g, _0x175767(423))), $(_0x175767(368))[_0x175767(510)] && ($(_0x175767(368))[_0x175767(344)](function (t) {
    const n = _0x175767, o = {
        qhkzf: "height", pyEcd: function (t, n) {
            return t(n)
        }, pJvVG: "minify_content-descritpion", ZsqGX: n(469)
    }, e = $(this)[n(511)]();
    $(this)[n(460)](o.qhkzf, e), 177 < e && o[n(485)]($, this)[n(319)](o.pJvVG)[n(436)](o[n(521)])
}), $(document).on(_0x175767(341), _0x175767(431), function () {
    const n = _0x175767, o = {
        Telmg: n(364), Ntzfd: "expanded", jGaOn: function (t, n) {
            return t(n)
        }, XJXCu: n(496), QhOzv: n(511)
    }, e = o[n(409)]($, this), t = e[n(455)](".minify_content-descritpion");
    e.hasClass(o.Ntzfd) ? t[n(441)]({height: o[n(480)]}, 10, function () {
        const t = n;
        e.text(o.Telmg)[t(422)](t(451))
    }) : t[n(441)]({height: t.data(o.QhOzv)}, 10, function () {
        const t = n;
        e.text("")[t(319)](o[t(417)])
    })
})), $(".scora")[_0x175767(510)] && ($(_0x175767(393))[_0x175767(344)](function (t) {
    const n = _0x175767, o = {
        bmsFl: function (t, n) {
            return t(n)
        }, IuuPX: n(450), padod: n(365), nHYpw: n(493), KmBTQ: function (t, n) {
            return t(n)
        }, EUdKd: function (t, n) {
            return t(n)
        }, dYmXD: "height", qMtwS: function (t, n) {
            return n < t
        }, FKDOj: function (t, n) {
            return t(n)
        }, FPcVg: n(457), bRpQF: n(351), fLeRN: function (t, n) {
            return t(n)
        }
    };
    o.bmsFl($, "#tabs-2").css({
        display: o[n(459)],
        visible: o[n(461)]
    }), o[n(369)]($, o.nHYpw)[n(528)]({display: o[n(459)], visible: o[n(461)]});
    var e = o.KmBTQ($, this)[n(511)]();
    o[n(367)]($, this).data(o[n(538)], e), o[n(374)](e, 56) && o.FKDOj($, this).addClass(n(505))[n(436)](n(339)), o[n(394)]($, n(356))[n(528)]({
        display: o[n(438)],
        visible: o.bRpQF
    }), o[n(420)]($, o[n(329)]).css({display: o[n(438)], visible: o[n(355)]})
}), $(document).on(_0x175767(341), _0x175767(431), function () {
    const n = _0x175767, o = {
        OfIIX: n(530), BBoqJ: n(451), IErGP: function (t, n) {
            return t(n)
        }, oyqqX: ".minify_content-info"
    }, e = o[n(437)]($, this), t = e[n(455)](o[n(385)]);
    e.hasClass(o.BBoqJ) ? t[n(441)]({height: "56"}, 10, function () {
        const t = n;
        e[t(382)](o.OfIIX)[t(422)](o[t(407)])
    }) : t[n(441)]({height: t[n(460)]("height")}, 10, function () {
        const t = n;
        e.html(o[t(432)])[t(319)](o[t(407)])
    })
})), $(document).on("click", ".favmod", function (t) {
    const o = _0x175767, n = {
        ARmup: o(371), poykk: function (t, n) {
            return t + n
        }, ETEiC: function (t, n) {
            return t - n
        }, XrRsR: function (t, n) {
            return t(n)
        }, YRjaC: o(503), wwtpr: function (t, n) {
            return t(n)
        }, NWnEh: ".favmod", RTiWl: function (t, n) {
            return n < t
        }, PNRsS: function (t, n) {
            return t(n)
        }, RtsmN: o(484), NePKa: function (t, n) {
            return t(n)
        }, IMWKs: "engine/ajax/dlefavorites.php", ksELd: o(322), sFFDE: "json", kDfQW: o(488)
    };
    t.preventDefault();
    const e = n.wwtpr($, this);
    n[o(507)]($, n[o(471)])[o(531)](e)[o(422)](n[o(519)]), e[o(342)](n[o(519)]), n.RTiWl($(o(400))[o(510)], 0) ? n[o(466)]($, n[o(390)])[o(319)](o(371)) : n[o(482)]($, n.RtsmN)[o(422)](n[o(519)]);
    let c = n[o(466)](parseInt, n[o(517)]($, n.YRjaC).text());
    n[o(517)](ShowLoading, ""), $[o(320)]({
        url: dle_root + n[o(346)],
        type: n[o(472)],
        dataType: n.sFFDE,
        data: {newsid: e[o(460)]("id"), favid: e[o(460)](n.kDfQW)}
    }).done(function () {
        const t = o;
        c = e[t(454)](n.ARmup) ? n.poykk(c, 1) : n[t(479)](c, 1), n.XrRsR($, n.YRjaC)[t(354)](c), n[t(507)](listenerCoundFav, c)
    })[o(391)](function (t) {
        const n = o;
        DLEalert(t[n(539)], dle_info)
    })[o(326)](function () {
        HideLoading()
    })
}), $(function () {
    const n = _0x175767, o = {
        hWEGu: function (t, n) {
            return t(n)
        }, cKGKc: function (t, n) {
            return n < t
        }, wSXbD: n(473), iQYNk: function (t, n) {
            return n <= t
        }, yxLnX: function (t, n) {
            return t + n
        }, swPuv: function (t, n) {
            return t - n
        }, LLtgN: function (t, n) {
            return t(n)
        }, BAfal: n(529), KytoS: n(458), mmEmq: function (t, n) {
            return t(n)
        }, cUcbc: function (t, n) {
            return t(n)
        }, KukHF: n(360), NDQMY: n(341), oyLvW: "#det-tabs", Buuan: n(340)
    }, e = o[n(376)]($, o.BAfal), t = o[n(495)]($, o[n(389)]);
    e[n(528)]("opacity", "0"), t.on(o[n(380)], function () {
        const t = n;
        return o[t(453)]($, t(324))[t(441)]({scrollTop: 0}, 400), !1
    });
    const c = o.cUcbc($, window);
    c[n(494)](function () {
        const t = n;
        o.cKGKc(c[t(383)](), 1500) ? e.css(o[t(334)], "1") : e[t(528)](t(473), "0"), o[t(416)](o[t(513)](c.height(), c.scrollTop()), o[t(392)](o[t(415)]($, document).height(), 1)) ? o.LLtgN($, o[t(353)])[t(319)](o.KytoS) : $(o[t(353)])[t(422)](o[t(333)])
    }), o.cUcbc($, o[n(414)]).tabs({
        show: {
            effect: n(426),
            duration: 300
        }
    }), o[n(495)]($, o.Buuan)[n(372)]({show: {effect: "fade", duration: 300}})
}), $(document)[_0x175767(449)](function (t) {
    const n = _0x175767, o = {
        uPtDS: function (t, n) {
            return t == n
        }, tBkxo: function (t) {
            return t()
        }
    };
    o[n(408)](t[n(345)], 27) && o[n(499)](searchClosePopup)
});
